var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropzoneElement",class:{ 'vue-dropzone dropzone': _vm.includeStyling },attrs:{"id":_vm.id}},[(_vm.useCustomSlot)?_c('div',{staticClass:"dz-message"},[_vm._t("default",[_vm._v("Drop files here to upload")])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }